export const texts = {
  default: {
    quiz: {
      back: "Back",
      continueButton: "Continue",
      steps: {
        second_screen: {
          middleText: {
            __html: `But don't worry, we're here to help.
                        <b>Based on your answers,</b> we can suggest nearby
                        fishing hot spots that may be a better
                        <b>match for you.</b>
                    
`,
          },
          topText: {
            __html: `“You are not alone -
                        <b>many anglers face these problems too.</b>`,
          },
          helpText: `There's only a handful of questions left, keep going 🎣`,
          dynamicTextStandard: `So don't give up just yet! Keep answering the questions.And you'll find your next big catch and favorite spot. Tight lines!”`,
        },
        state: {
          help: "so we can start making a personal map for you",
          placeholder: "Your state",
          save: "Your data is safe.",
          bottom: "We need this to find fishing spots near your location.",
        },
        city: {
          help: "Choose your city:",
          placeholder: "Your city",
          save: "Your data is safe.",
          bottom: "We need this to find fishing spots near your location.",
          no_options: "No options",
          at_least: "Enter at least 3 characters",
        },
        analyze: {
          complete: "Your personal map is complete",
          help: "Trusted by over 752,104 anglers",
          slideText: `“Fishing forecast works very well, the hour that was set
                    for minor feeding brought a ton of bites. We caught lots
                    of fish and my kids were super happy! Definitely
                    recommend it 👍”
`,
          slideName: "Stan V, Verified Customer",
        },
        email: {
          enter_email: "Enter your email to get started",
          placeholder: "Your email",
          error_message: "Your email address is not valid.",
          button: "See my map",
          info_top: `Your information is 100% secure. Fishbox does not share your
                        personal information with third parties`,
          info_bottom: `By submitting your email address, you may also receive email
                        offers from Fishbox about our services. You may unsubscribe
                        at any time.`,
          privacy: "Privacy Policy",
        },
      },
      land: {
        stay: {
          __html: `Stay ahead in the game and start catching more fish
                    <br> with confidence today!`,
        },
        based_1: "Based on your answers, we recommend",
        based_2: "Based on your answers, we recommend a",
        orange_1: "27 spots",
        orange_2: "27 Hotspots",
        near_1: "near",
        near_2: "map near",
        wasting: "Stop wasting precious time",
        wasting_2:
          " Our advanced location analysis guides you to the best fishing spots, guaranteed!",
        percents: [
          {
            percent: 82,
            text: "of our users caught their biggest fish ever in just 4 weeks of using our product",
          },
          {
            percent: 76,
            text: "of our users reported feeling less stressed and more relaxed while fishing",
          },
          {
            percent: 59,
            text: "of our users had a difficulty finding the right fishing spots before using our product",
          },
        ],
        button_text: "See my map",
        button_text_lures: "See my spots",
        get_access: `You'll also get access to:`,
        forecast_title: "Our forecast includes the most accurate weather data",
        includesArray: [
          "We work with GFS, NAM and ECMWF forecast models.",
          "We get new data every 30 min",
          "You will be able to analyze any weather changes in our hourly mode",
        ],
        tools: "Our Tools Will Help You:",
        helpArray: [
          "Use the forecast for your favorite places as well",
          `Don't leave your fishing success in fate's hands`,
          "Say goodbye to wasted fishing trips",
        ],
        collaborates: "Fishbox collaborates with:",
        member: "We’re an official member of the ASA",
        bordered_top: (
          price = "$1"
        ) => `With the upcoming fishing season, we are
                offering to try out Fishbox for only $1 for
                7-day trial*.`,
        bordered_bottom: `Don't let financial concerns stop you from
                getting to the best fishing spots. See for
                yourself how our expert analysis and accurate
                weather forecasts can help you catch more fish.
                So choose an amount that you think is reasonable
                to try us out.`,
        most_popular: " most popular choice*",
        day_trial: "*7-day trial",
        trial_end_prepend: "Your 7-day trial will last until",
        trial_end_after:
          "Then your Subscription Period will start and you will be charged",
        canceled: {
          __html: `<span className="text-[#002E38]">
                                You may cancel at any time
                            </span> 
                            - just write us a letter:
                            <a
                                href="mailto:support@my-stylist.pro"
                                target="_blank"
                                rel="noreferrer"
                            >
                                support@my-stylist.pro
                            </a>
                            and you will not be charged for the next
                            Subscription Period.`,
        },
        money_back_title: "100% money back guarantee",
        money_back_text: `We’re confident in the quality of our plan - hundreds of
                        thousands of anglers around the world enjoy it and reach
                        their goals with us. If you use Fishbox for 14 days and
                        still don’t like it, please contact us - we guarantee a
                        100% refund within 14 days of purchase.`,
        money_back_text_bottom: {
          __html: `Find more about the applicable limitations in our
                            <a
                                class='font-bold text-timerBlue'
                                target={'_blank'}
                                href="https://my-stylist.pro/refund_policy"
                            >
                            money-back guarantee.
                            </a>`,
        },
        money_back_text_guarantee: `money-back guarantee.`,
        bottom_1_title: "Your information is safe",
        bottom_1_text: `We won’t sell or rent your personal information for any
                marketing purposes whatsoever.`,
        bottom_2_title: "Secure checkout",
        bottom_2_text: `All information is encrypted and transmitted without risk
                using a Secure Sockets Layer protocol.`,
        bottom_3_title: "Need help?",
        bottom_3_text: "Contact us",
        privacy: "Privacy Policy",
        terms: "Terms of Service",
      },
      payment: {
        modal: {
          title: "Payment method",
          prepend: "You will only be charged",
          append: "",
          card_number_placeholder: "Card number",
          button_text: "Continue",
          or: "or",
        },
        check_email_popup: {
          hey: "Hey, You Already Have",
          active_subscription: "Active Subscription!",
          email: (
            email: string
          ) => `We've found an active subscription for <b>${email}</b>.  You
                    can go to the app and take full advantage of Fishbox!`,
          go: "Go to App",
          i_want_buy: "I want to buy a subscription again",
        },
      },
      finish: {
        title: "Congratulations!",
        text_prepend: " Now you’re a member of",
        text_append: "Let’s enjoy unlimited access.",
        how_text: "How to install the App:",
        how_items: [
          "1. Open the Camera app",
          "2. Point the camera at this QR code",
          "3. Wait for the notification",
          "4. Tap the notification",
          "5. Install the app",
        ],
        button_text: "Create account",
        button_text_2: "Install Fishbox",
      },
    },
  },
};
